<template>
	<div id="footer">
		<div>

			<!----------------------------------------------------
				Copyright
			------------------------------------------------------->
			<div>
				&copy;{{ year }} armslist.deals
			</div>

			<!----------------------------------------------------
				Links
			------------------------------------------------------->
			<div>
				<router-link to="/about-us">About</router-link>
				<span class="divider">|</span>
				<router-link to="/contact-us">Contact</router-link>
				<span class="divider">|</span>
				<router-link to="/privacy-policy">Privacy Policy</router-link>
				<span class="divider">|</span>
				<router-link to="/terms-and-conditions">Terms &amp; Conditions</router-link>
			</div>

		</div>
	</div>
</template>

<script>
export default {
	name: "Footer",
	data: function() {
		return {
			keywords: ""
		}
	},
	computed: {
		year() {
			return new Date().getFullYear();
		}
	},
	methods: {

		//
		search() {
			//
		}

	}
};
</script>

<style lang="scss">
#footer {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 100px;
	z-index: 10;
	margin-top: -100px;
	padding: 0 20px;
	background-image: url('../../public/images/bg-body.png');
	background-repeat: no-repeat;
	background-size: cover;
	color: #fff;

	>* {
		position: relative;
		max-width: 1300px;
		height: 100px;
		margin: 0 auto;
		padding: 15px 0;
		
	}

	a {
		color: #fff;
		text-decoration: none;
	}

	.divider {
		padding: 0 15px;
	}

	//
	@media ( min-width: 768px ) {
		>* {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0;
		}
	}

	//
	@media (hover) {
		a {
			&:hover {
				text-decoration: underline;
			}
		}
	}
}
</style>